export default {
  /**
   * Install plugin.
   * @param Vue
   * @param options
   *   Options is an object like:
   *     - debug
   */
  install(Vue, options) {
    /*eslint-disable */
    Vue.debug = options.debug || false;

    new Vue({
      created() {
        this.$events.on('log', (status, ...args) => {
          console.log(status, ...args);
        });
      },
    });

    /*eslint-enable */

    Vue.mixin({
      methods: {
        get debug() {
          return Vue.debug;
        },

        /**
         * Allow component to log message.
         * Allow other plugin to take into account of this log with a log
         * event.
         * @param {string} status
         *   Status may be:
         *     - 'status'
         *     - 'error'
         *     - 'debug'
         *     - or any other status taken into account by plugin that listen
         *     to the log event.
         * @param args
         */
        log(status, ...args) {
          if (Vue.debug) {
            this.$events.emit('log', status, ...args);
          }
        },
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/plugins/debug/debug.js